<div class="col-sm-10 col-md-8 col-lg-6 mx-auto mt-5" *ngIf="checksLoaded">
  <div class="card card-body">
    <h2 class="mb-3 text-center">
      <!--<fa-icon [icon]="faSignInalt" size="xs"></fa-icon>-->
      {{
        passwordRecovery || changePasswordAtLogin
          ? "Change Password"
          : "Set New Password"
      }}
    </h2>

    <div class="col-md-8 m-auto pr-0 pl-0">
      <!-- <div class="col-md-6 m-auto pr-0 pl-0"> -->

      <p class="text-center" *ngIf="changePasswordAtLogin">
        You must change your password to continue.
      </p>

      <app-password-change-form
        [changePasswordAtLogin]="changePasswordAtLogin"
        [recoveryToken]="recoveryToken"
        [oldPassword]="oldPassword"
        [passwordRecovery]="passwordRecovery"
        (passwordChanged)="passwordChanged($event)"
      ></app-password-change-form>
    </div>
  </div>
</div>
